/**
 * @generated SignedSource<<df47d9fafd7e8105e8a097c548af0c49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateExpenseCategoryInput = {
  id: string;
  name?: string | null;
  disabled?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateExpenseCategoryMutation$variables = {
  input: UpdateExpenseCategoryInput;
};
export type updateExpenseCategoryMutation$data = {
  readonly updateExpenseCategory: {
    readonly expenseCategory: {
      readonly id: string;
      readonly name: string | null;
      readonly disabled: boolean | null;
      readonly canDelete: boolean | null;
    } | null;
  } | null;
};
export type updateExpenseCategoryMutation = {
  variables: updateExpenseCategoryMutation$variables;
  response: updateExpenseCategoryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateExpenseCategoryPayload",
    "kind": "LinkedField",
    "name": "updateExpenseCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExpenseCategory",
        "kind": "LinkedField",
        "name": "expenseCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "disabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canDelete",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateExpenseCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateExpenseCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "098278c04e70831f11765c03571e52d4",
    "id": null,
    "metadata": {},
    "name": "updateExpenseCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation updateExpenseCategoryMutation(\n  $input: UpdateExpenseCategoryInput!\n) {\n  updateExpenseCategory(input: $input) {\n    expenseCategory {\n      id\n      name\n      disabled\n      canDelete\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9dcfba91c5dd846b0f9ffe79fe0fb9be";

export default node;
